import BulletListIcon from "@atlaskit/icon/glyph/bullet-list";
import CalendarIcon from "@atlaskit/icon/glyph/calendar";
import FeedbackIcon from "@atlaskit/icon/glyph/feedback";
import FileIcon from "@atlaskit/icon/glyph/file";
import FlagFilledIcon from "@atlaskit/icon/glyph/flag-filled";
import GraphLineIcon from "@atlaskit/icon/glyph/graph-line";
import IssuesIcon from "@atlaskit/icon/glyph/issues";
import MenuIcon from "@atlaskit/icon/glyph/menu";
import QuestionCircleIcon from "@atlaskit/icon/glyph/question-circle";
import RoadmapIcon from "@atlaskit/icon/glyph/roadmap";
import SendIcon from "@atlaskit/icon/glyph/send";
import StarFilledIcon from "@atlaskit/icon/glyph/star-filled";

export const iconCollectionSoftwareDev = [
    {
        icon: <GraphLineIcon size="small" label="" />,
        description: "Analytics"
    },
    {
        icon: <RoadmapIcon size="small" label="" />,
        description: "Progress tracking"
    },
    {
        icon: <IssuesIcon size="small" label="" />,
        description: "Sprint planning"
    },
    {
        icon: <MenuIcon size="small" label="" />,
        description: "Forms"
    }
];
export const iconCollectionMarketing = [
    {
        icon: <BulletListIcon size="small" label="" />,
        description: "Progress tracking"
    },
    {
        icon: <CalendarIcon size="small" label="" />,
        description: "Calendar view"
    },
    {
        icon: <MenuIcon size="small" label="" />,
        description: "Forms"
    },
    {
        icon: <FileIcon size="small" label="" />,
        description: "Reporting"
    }
];
export const iconCollectionIt = [
    {
        icon: <FlagFilledIcon size="small" label="" />,
        description: "Resolve incidents"
    },
    {
        icon: <QuestionCircleIcon size="small" label="" />,
        description: "Help desk"
    },
    {
        icon: <SendIcon size="small" label="" />,
        description: "Manage requests"
    },
    {
        icon: <FeedbackIcon size="small" label="" />,
        description: "Reporting"
    }
];
export const iconCollectionDesign = [
    {
        icon: <BulletListIcon size="small" label="" />,
        description: "Task planning"
    },
    {
        icon: <QuestionCircleIcon size="small" label="" />,
        description: "Progress tracking"
    },
    {
        icon: <SendIcon size="small" label="" />,
        description: "Prioritization"
    },
    {
        icon: <FileIcon size="small" label="" />,
        description: "Forms"
    }
];
export const iconCollectionOperations = [
    {
        icon: <BulletListIcon size="small" label="" />,
        description: "Task planning"
    },
    {
        icon: <RoadmapIcon size="small" label="" />,
        description: "Progress tracking"
    },
    {
        icon: <StarFilledIcon size="small" label="" />,
        description: "Prioritization"
    },
    {
        icon: <MenuIcon size="small" label="" />,
        description: "Forms"
    }
];
export enum TemplateKey {
    SimplifiedBasic = "com.pyxis.greenhopper.jira:gh-simplified-basic",
    Scrum = "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum",
    Kanban = "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban",
    WebDesignProcess = "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process",
    GoToMarket = "com.atlassian.jira-core-project-templates:jira-work-management-go-to-market",
    SimplifiedProcessControl = "com.atlassian.jira-core-project-templates:jira-core-simplified-process-control",
    SalesPipeline = "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline",
    SimplifiedProcurement = "com.atlassian.jira-core-project-templates:jira-core-simplified-procurement",
    EmployeeOnboarding = "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding",
    PersonalTaskPlanner = "com.atlassian.jira-core-project-templates:jira-work-management-personal-task-planner"
}
